var _path, _g, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 104,
    viewBox: "0 0 103 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4863_3967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 89,
    height: 89
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.4741 88.9741H1.47412V0.974121H89.4741V88.9741Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4863_3967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9741 88.9741H6.97412C3.85751 88.9741 1.47412 86.5907 1.47412 83.4741V6.47412C1.47412 3.35751 3.85751 0.974121 6.97412 0.974121H68.5741L89.4741 21.8741V83.4741C89.4741 86.5907 87.0907 88.9741 83.9741 88.9741Z",
    fill: "#0C3891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5742 0.974121L89.4742 21.8741H68.5742V0.974121Z",
    fill: "#2859BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90723 79.9909V54.8743V41.6743V18.9409H56.1073V20.7743H32.6405C32.0905 32.1409 23.1071 41.3077 11.7405 41.6743V54.8743H35.0239V78.1577H50.0573V49.5577H39.9739V47.7243H51.7073V78.1577H68.9407V67.7077H61.2407V65.8743H68.9407V35.2577H70.7739V79.9909H9.90723ZM30.8073 20.9577H11.7405V40.0243C22.0073 39.4743 30.4405 31.2243 30.8073 20.9577ZM33.1905 56.8909H11.7405V78.1577H33.1905V56.8909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5908 70.8241V72.6575H74.8076V70.8241H77.1908V50.4741H74.8076V48.6407H77.1908V28.2907H74.8076V26.4575H81.5908V28.2907H79.0242V48.6407H81.5908V50.4741H79.0242V70.8241H81.5908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7907 13.6244H41.4407V16.0078H39.6074V13.6244H19.0741V16.0078H17.2407V9.40771H19.0741V11.791H39.6074V9.40771H41.4407V11.791H61.7907V9.40771H63.6241V16.0078H61.7907V13.6244Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.026 84C101.026 94.2316 92.7316 102.526 82.5 102.526C72.2685 102.526 63.9741 94.2316 63.9741 84C63.9741 73.7685 72.2685 65.4741 82.5 65.4741C92.7316 65.4741 101.026 73.7685 101.026 84Z",
    fill: "white",
    stroke: "#ECEFF1",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7256 75.1476C79.7256 73.5621 80.9147 72.373 82.5002 72.373C83.9536 72.373 85.2748 73.5621 85.2748 75.1476V93.1165C85.2748 94.702 84.0857 95.8912 82.5002 95.8912C80.9147 95.8912 79.7256 94.702 79.7256 93.1165V75.1476Z",
    fill: "#00BCDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5183 76.9974C79.4614 75.9404 79.4614 74.2227 80.5183 73.1657C81.5753 72.1088 83.293 72.1088 84.35 73.1657L90.6919 79.5077C91.7489 80.5647 91.7489 82.2823 90.6919 83.3393C89.6349 84.3963 87.9173 84.3963 86.8603 83.3393L80.5183 76.9974Z",
    fill: "#00BCDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5183 73.1657C81.5753 72.1088 83.2929 72.1088 84.3499 73.1657C85.4069 74.2227 85.4069 75.9404 84.3499 76.9974L78.14 83.3393C77.083 84.3963 75.3654 84.3963 74.3084 83.3393C73.2514 82.2823 73.2514 80.5647 74.3084 79.5077L80.5183 73.1657Z",
    fill: "#00BCDA"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload.a6669169ef1331bc2945da910a1b24f6.svg";